class ResultsBanner extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.eventBus = window.theme.nosto.eventBus
    this.events = window.theme.results.events

    window.nostoNoResults = false
  }

  connectedCallback () {
    super.connectedCallback()

    this.eventBus.subscribe(
      window.theme.results.events.STATE.SEARCH_TOTAL_UPDATED,
      this.handleSearchTotalUpdated.bind(this),
    )
  }

  handleSearchTotalUpdated (payload) {
    if (window.nostoNoResults) return

    this.renderTitle(payload)
    this.renderText(payload)

    this.updatePageTitle(payload)

    if (!payload.total) {
      window.nostoNoResults = true
      this.eventBus.publish(this.events.API.FETCH_PRODUCTS, {})
    }
  }

  renderTitle ({ total, activeTerm }) {
    let string = total
      ? this.els.title.element.dataset.formatResults
      : this.els.title.element.dataset.formatNoResults

    string = string
      .replaceAll('[count]', total)
      .replaceAll('[query]', activeTerm)

    this.els.title.element.innerText = string
  }

  renderText ({ total, activeTerm }) {
    let string = total
      ? this.els.text.element.dataset.formatResults
      : this.els.text.element.dataset.formatNoResults

    string = string
      .replaceAll('[count]', total)
      .replaceAll('[query]', activeTerm)

    this.els.text.element.innerText = string
  }

  updatePageTitle ({ total, activeTerm }) {
    let string =
      total === 1
        ? window.theme.strings.templates.search.pageTitle.one
        : window.theme.strings.templates.search.pageTitle.other

    string = string
      .replaceAll('[count]', total)
      .replaceAll('[query]', activeTerm)

    const txt = document.createElement('textarea')
    txt.innerHTML = string
    string = txt.value

    document.title = string
  }
}

if (!customElements.get('results-banner')) {
  customElements.define('results-banner', ResultsBanner)
}
